import React from "react";
import { createPortal } from "react-dom";
import "../style/Loading.css";
import LoadingGif from '../images/ui/Paw_V2.gif'

const Loading = ({ isVisible }) => {
  return createPortal(
    <div className={`loading-overlay ${!isVisible ? "hidden" : ""}`}>
      <div className="spinner">
        <img src={LoadingGif} alt="loading..."/>
      </div>
    </div>,
    document.body
  );
};

export default Loading;
